/* eslint-disable */

import ls from '@/helpers/localStorage';
import { LS_MAINTENANCE_MESSAGE_KEY } from '@/components/app/app-header-notification/app-header-notification.vue';
import { SHOW_ODDS_KEY } from '@/components/market/price-odds-toggle-popup/price-odds-toggle-popup';

const LAYOUT_MOBILE = 'mobile';
const LAYOUT_DESKTOP = 'desktop';
const LAYOUT_SWITCH_BREAKPOINT = 910;

function getDefaultLayout() {
  const width = window.innerWidth ||
    document.documentElement.clientWidth ||
    document.getElementsByTagName('body')[0].clientWidth;
  return (width >= LAYOUT_SWITCH_BREAKPOINT) ? LAYOUT_DESKTOP : LAYOUT_MOBILE;
}

export default {
  namespaced: true,
  state: {
    previousRoute: null,
    initialVersion: null,
    serverVersion: null,
    skipAttachToHomeNotification: ls.get('skipAttachToHomeNotification', false),
    skipBanner: ls.get('skipBanner', false),
    hasServerErrorOccurred: false,
    layout: getDefaultLayout(),
    isTaxNotificationMandatory: false,
    hiddenMaintenanceMessage: ls.get(LS_MAINTENANCE_MESSAGE_KEY),
    maintenance: {
      isMaintenanceEnabled: false,
      isTradingEnabled: true,
      maintenanceMessage: '',
      suspendedMessage: '',
      systemMessage: '',
    },
    mobileMenuOpened: false,
    isTabActive: !document.hidden,
    liveUpdatesDisabled: false,
    firebaseInitialized: false,
    signalrInitialized: false,
    systemEmails: {
      support: process.env.EMAIL_SUPPORT,
      press: process.env.EMAIL_PRESS,
      markets: process.env.EMAIL_MARKETS
    },
    newLoaderCounter: 0,
    showOdds: !!process.env.ODDS_MODE_ENABLED ? ls.get(SHOW_ODDS_KEY, true) : false,
  },
  mutations: {
    setLiveUpdatesDisabled(state, flag) {
      state.liveUpdatesDisabled = flag;
    },
    setIsTabActive(state, data) {
      state.isTabActive = data;
    },
    setPreviousRoute(state, data) {
      state.previousRoute = data;
    },
    setInitialVersion(state, version) {
      state.initialVersion = version;
    },
    setServerVersion(state, version) {
      state.serverVersion = version;
    },
    setLayout(state, layout) {
      state.layout = layout;
    },
    setServerError(state, hasOccurred) {
      state.hasServerErrorOccurred = hasOccurred;
    },
    setFirebaseInitialized(state, flag) {
      state.firebaseInitialized = flag;
    },
    setSignalrInitialized(state, flag) {
      state.signalrInitialized = flag;
    },
    setMaintenance(state, data) {
      state.maintenance = data;
    },
    setMandatoryTaxNotification(state, flag) {
      state.isTaxNotificationMandatory = flag;
    },
    dontShowAttachToHomeNotification(state) {
      const expiresAt = 31536000; // 1 year
      ls.set('skipAttachToHomeNotification', true, expiresAt);
      state.skipAttachToHomeNotification = true;
    },
    dontShowBanner(state) {
      state.skipBanner = true;
    },
    toggleMobileMenu(state) {
      state.mobileMenuOpened = !state.mobileMenuOpened;
    },
    closeMobileMenu(state) {
      state.mobileMenuOpened = false;
    },
    setHiddenMaintenanceMessage(state, value) {
      state.hiddenMaintenanceMessage = value;
    },
    incrNewLoaderCounter(state) {
      state.newLoaderCounter = state.newLoaderCounter + 1;
    },
    decrNewLoaderCounter (state) {
      state.newLoaderCounter = state.newLoaderCounter - 1;
      if (state.newLoaderCounter < 0) {
        state.newLoaderCounter = 0;
      }
    },
    resetLoaderCounter(state) {
      state.newLoaderCounter = 0;
    },
    setShowOdds(state, flag) {
      state.showOdds = flag;
    },
  },
  getters: {
    isLayoutMobile: state => state.layout === LAYOUT_MOBILE,
    isLayoutDesktop: state => state.layout === LAYOUT_DESKTOP,
    isShutdownModeOn: state => !!process.env.SHUTDOWN_ENABLED,
    isPinningEnabled: state => !!process.env.PINNING_ENABLED,
    leaderboardsEnabled: state => !!process.env.LEADERBOARDS_ENABLED,
    oddsModeEnabled: state => !!process.env.ODDS_MODE_ENABLED,
    hasMaintenanceMessage: (state) => {
      if (state.maintenance.maintenanceMessage) return true;
      const maintenanceMessage = state.maintenance.suspendedMessage ||
        state.maintenance.systemMessage;
      // check if message was hidden by user;
      return maintenanceMessage && maintenanceMessage !== state.hiddenMaintenanceMessage;
    },
    hasMaintenance: state => (
      state.maintenance.maintenanceMessage ||
      state.maintenance.suspendedMessage
    ),
    hasMaintenanceSuspended: state => !!state.maintenance.suspendedMessage,
    hasBanner: (state, getters, rootState, rootGetters) => process.env.BANNER_ENABLED &&
    !state.skipBanner && rootGetters['user/isLoggedIn'],
    isAfterHours: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 2;
      return false;
    },
    isRegularMaintenance: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 3;
      return false;
    },
    isExtendedMaintenance: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 4;
      return false;
    },
    isFullMaintenance: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 5;
      return false;
    },
    isTradingEnabled: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isCancelOrdersEnabled: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isDepositEnabled: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isWithdrawEnabled: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isCommentEnabled: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isLoginEnabled: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isSignUpEnabled: (state) => {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    newLoaderIsLoading: (state) => state.newLoaderCounter > 0,
  },
  actions: {
    setHiddenMaintenanceMessage({ commit }, value) {
      commit('setHiddenMaintenanceMessage', value);
    },
    setInitialVersion({ commit }, data) {
      commit('setInitialVersion', data);
    },
    setServerVersion({ commit }, data) {
      commit('setServerVersion', data);
    },
    setLayoutWidth({ commit }, width) {
      if (width >= LAYOUT_SWITCH_BREAKPOINT) {
        commit('setLayout', LAYOUT_DESKTOP);
      } else {
        commit('setLayout', LAYOUT_MOBILE);
      }
    },
    setServerError({ commit }, hasOccurred) {
      commit('setServerError', hasOccurred);
    },
    setMaintenance({ commit }, data) {
      commit('setMaintenance', data);
    },
    setMandatoryTaxNotification({ commit }, flag) {
      commit('setMandatoryTaxNotification', flag);
    },
    dontShowAttachToHomeNotification({ commit }) {
      commit('dontShowAttachToHomeNotification');
    },
    dontShowBanner({ commit }) {
      commit('dontShowBanner');
    },
    setPreviousRoute({ commit }, data) {
      commit('setPreviousRoute', data);
    },
    toggleMobileMenu({ commit }) {
      commit('toggleMobileMenu');
    },
    closeMobileMenu({ commit }) {
      commit('closeMobileMenu');
    },
    setIsTabActive({ commit }, flag) {
      commit('setIsTabActive', flag);
    },
    setLiveUpdatesDisabled({ commit }, flag) {
      commit('setLiveUpdatesDisabled', flag);
    },
    setFirebaseInitialized({ commit }, flag) {
      commit('setFirebaseInitialized', flag);
    },
    setSignalrInitialized({ commit }, flag) {
      commit('setSignalrInitialized', flag);
    },
    incrNewLoaderCounter({ commit }) {
      commit('incrNewLoaderCounter')
    },
    decrNewLoaderCounter({ commit }) {
      commit('decrNewLoaderCounter')
    },
    resetLoaderCounter({ commit }) {
      commit('resetLoaderCounter');
    },
    setShowOdds({ commit }, flag) {
      commit('setShowOdds', flag);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js